// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-list[data-v-c79fb0bc]{-moz-columns:2;column-count:2}@media only screen and (min-width:600px){.feature-expansion[data-v-c79fb0bc]{width:65%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
